module.exports = __webpack_public_path__ + "img/emo_33.435dbb7f.gif";